module.exports = __webpack_public_path__ + "static/media/ic_exportOrange.45e4a931.svg";